/* static/js/live_v2/studio_diff.js — BO Dashboard Studio diff (P5).
 *
 * Pure: compares a saved version's layout against the LIVE board and returns a
 * structured diff. Kept out of the controller so it's unit-testable under Node
 * with a tiny window shim (tests/js/studio_diff.test.js), same as LSGraphs.
 *
 *   compute(liveSections, versionLayout) -> { tabsRemoved, sections, hasChanges }
 *
 *   liveSections  : [{ id, label, layout:{scoreboard_id,kpis,panels,widgetOpts} }]
 *                   (what get_preset_full returns — published override else code)
 *   versionLayout : { sections:{<id>:{…}}, section_order:[{id,label}] }
 *   sections[]    : per CHANGED section — { id, label, isNew, kpisAdded,
 *                   kpisRemoved, panelsAdded, panelsRemoved, panelsMoved,
 *                   scoreboardChanged }.  New tabs surface here flagged isNew.
 */
window.LSStudioDiff = (function () {
  'use strict';

  function compute(liveSections, versionLayout) {
    var liveById = {};
    (liveSections || []).forEach(function (sec) {
      liveById[sec.id] = { label: sec.label, layout: sec.layout || {} };
    });
    var layout    = versionLayout || {};
    var vsecs     = layout.sections || {};
    var orderMeta = (layout.section_order && layout.section_order.length)
      ? layout.section_order
      : Object.keys(vsecs).map(function (id) { return { id: id }; });
    var order   = orderMeta.map(function (o) { return o.id; });
    var liveIds = Object.keys(liveById);

    var tabsRemoved = liveIds.filter(function (id) { return order.indexOf(id) < 0; });
    var sections = [];

    order.forEach(function (id) {
      var cand  = vsecs[id] || {};
      var live  = (liveById[id] && liveById[id].layout) || {};
      var isNew = !liveById[id];
      var candKpis = cand.kpis || [], liveKpis = live.kpis || [];
      var candPanels = cand.panels || [], livePanels = live.panels || [];
      var candIds  = candPanels.map(function (p) { return p.id; });
      var liveIdsP = livePanels.map(function (p) { return p.id; });
      var liveP = {}; livePanels.forEach(function (p) { liveP[p.id] = p; });

      var kpisAdded     = candKpis.filter(function (k) { return liveKpis.indexOf(k) < 0; });
      var kpisRemoved   = liveKpis.filter(function (k) { return candKpis.indexOf(k) < 0; });
      var panelsAdded   = candIds.filter(function (p) { return liveIdsP.indexOf(p) < 0; });
      var panelsRemoved = liveIdsP.filter(function (p) { return candIds.indexOf(p) < 0; });
      var panelsMoved   = candPanels.filter(function (p) {
        var lp = liveP[p.id];
        return lp && (lp.x !== p.x || lp.y !== p.y || lp.w !== p.w || lp.h !== p.h);
      }).map(function (p) { return p.id; });
      var scoreboardChanged = (cand.scoreboard_id || null) !== (live.scoreboard_id || null);

      if (isNew || kpisAdded.length || kpisRemoved.length || panelsAdded.length
          || panelsRemoved.length || panelsMoved.length || scoreboardChanged) {
        var meta = orderMeta.find(function (o) { return o.id === id; }) || {};
        sections.push({
          id: id,
          label: (liveById[id] && liveById[id].label) || meta.label || id,
          isNew: isNew,
          kpisAdded: kpisAdded, kpisRemoved: kpisRemoved,
          panelsAdded: panelsAdded, panelsRemoved: panelsRemoved,
          panelsMoved: panelsMoved, scoreboardChanged: scoreboardChanged,
        });
      }
    });

    return {
      tabsRemoved: tabsRemoved,
      sections: sections,
      hasChanges: !!(tabsRemoved.length || sections.length),
    };
  }

  return { compute: compute };
})();
